import { array, string } from 'yup';
import { FieldType } from '@widgets/EnquiryForm/types/config';
export const generateCheckboxSchemaObject = ({ type, required, options }) => {
    if (type !== FieldType.CheckboxInput)
        return null;
    const requiredValues = options.map((option) => (option.required ? option.value : false)).filter(Boolean);
    let fieldValidation = array().of(string());
    if (requiredValues.length > 0) {
        fieldValidation = fieldValidation.test({
            name: 'requiredCheckboxes',
            message: ({ value }) => ({
                overall: 'Please check the required checkboxes',
                fields: requiredValues.filter((requiredValue) => !value.includes(requiredValue)),
            }),
            test: (value) => {
                if (!value || !value.length)
                    return false;
                return requiredValues.every((innerVal) => innerVal && value.includes(innerVal));
            },
            params: {
                requiredValues,
            },
        });
    }
    if (required) {
        fieldValidation = fieldValidation.min(1);
    }
    return fieldValidation;
};
